import { useEffect, useMemo, useState } from 'react';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { logError } from '@helpers/errors';
import {
    SiteWideDemoFormStructure,
    translatedSiteWideDemoFormStructure,
} from '@components/SiteWideDemoForm/siteWideDemoFormHelpers';
import siteWideDemoFormStructureDefault from '@components/SiteWideDemoForm/siteWideDemoFormStructure/en';

export function useLazyLoadedSiteWideDemoFormStructure(): SiteWideDemoFormStructure {
    const [siteWideDemoFormStructure, setSiteWideDemoFormStructure] = useState<SiteWideDemoFormStructure>(
        siteWideDemoFormStructureDefault
    );
    const [selectedLanguage] = useAtom(selectedLanguageAtom);

    const dynamicImports = useMemo(() => {
        const dynamicImport = import(
            /* webpackChunkName: "siteWideDemoFormStructure" */ `@components/SiteWideDemoForm/siteWideDemoFormStructure/${translatedSiteWideDemoFormStructure[selectedLanguage]}`
        );
        return dynamicImport;
    }, [selectedLanguage]);

    useEffect(() => {
        dynamicImports
            .then((loader) => {
                setSiteWideDemoFormStructure(loader.default);
            })
            .catch((error) => logError(error, 'get/set dynamic imports'));
    }, [dynamicImports]);

    return siteWideDemoFormStructure;
}
